import { FC, useContext, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { ISchedule } from "../api/getSchedulesAvailable";
import CheckoutStepper from "../components/checkout/CheckoutStepper";
import PageWrapper from "../components/common/PageWrapper";
import ProfessionalProfile from "../components/common/ProfessionalProfile";
import CheckoutContext from "../context/checkoutContext/checkoutContext";
import { formatDate } from "../utils/date-util/dateUtils";

const AppointmentInformation = styled.div`
	font-family: Livvic;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 165.5%;
	color: ${props => props.theme.colors.blackVitat || "#002b49"};
	text-align: left;
	padding: 0px 24px 16px 24px;
`;

/**
 * ### Tela de checkout do atendimento.
 * Pede para o usuario todos os dados necessário para efetuar o pagamento
 */
const CheckoutScreen: FC = () => {
	const { professionalId } = useParams<{ professionalId: string }>();
	const location = useLocation();
	const scheduleInfo = (location.state as ISchedule | undefined) ?? undefined;
	const checkoutContext = useContext(CheckoutContext);

	useEffect(() => {
		if (checkoutContext.setContext && scheduleInfo) {
			checkoutContext.setContext({
				scheduleInfo: scheduleInfo,
			});
		}
	}, [scheduleInfo]);

	return (
		<PageWrapper>
			<ProfessionalProfile canSeeReviews={false} showOfferedProcedures={false} showMoreAboutButton={true} codProfessional={professionalId} />

			{scheduleInfo && scheduleInfo.procedimento && (
				<AppointmentInformation>
					<b>Informações do agendamento: </b> {scheduleInfo.procedimento.descricao}, {formatDate("dd/MM 'as' HH:mm'h'", scheduleInfo.horarioInicial)}
				</AppointmentInformation>
			)}

			<CheckoutStepper />
		</PageWrapper>
	);
};

export default CheckoutScreen;
